import React, { useState, useRef } from "react";
import classnames from "classnames";
import { ThemeProvider } from "styled-components";
import theme from "../../themes/default";
import Exclusions from "../../molecules/Exclusions";
import Diet from "../../molecules/Diet";
import { ReactComponent as Toggle } from "./../../atoms/icons/chevron-flat.svg";
import { Wrap, Inner, ToggleButton } from "./styles";

function Excludes(props) {
  const { exclusions, selectedExclusions, diets, selectedDiet, compactHeader, mode, main_title } = props;
  const [sticky] = useState(false);
  let wrapRef = useRef(null);
  let innerWrapRef = useRef(null);

  const handleExclusionChange = (e, reference) => {
    props.exclusionChange(e, reference);
  };

  const handleDietChange = (e) => {
    props.dietChange(e);
  };

  const handleCompactModeClick = () => {
    props.handleCompactModeClick();
  };
  return (
    <ThemeProvider theme={theme}>
      <Wrap ref={wrapRef} className={classnames({ active: compactHeader }, { account: mode === "account" }, { single: !diets.length })}>
        <Inner className={classnames("inner-settings", { sticky: sticky })} ref={innerWrapRef}>
          {compactHeader === false && (
            <>
              <Exclusions
                exclusions={exclusions}
                selectedExclusions={selectedExclusions}
                exclusionChange={handleExclusionChange}
                main_title={main_title}
              />
              {diets.length > 0 && <Diet diets={diets} selectedDiet={selectedDiet} dietChange={handleDietChange} />}
            </>
          )}

          <ToggleButton className={classnames({ active: compactHeader })} onClick={handleCompactModeClick}>
            <Toggle />
          </ToggleButton>
        </Inner>
      </Wrap>
    </ThemeProvider>
  );
}

export default Excludes;
